import { statusTypes } from '@app/origami-api/constants/statuses';

export enum AmendmentStatus {
  Pending = 1,
  Completed = 2,
}

export const AMENDMENT_STATUS_MAP: Record<AmendmentStatus, statusTypes> = {
  [AmendmentStatus.Pending]: 'PENDING',
  [AmendmentStatus.Completed]: 'COMPLETED',
};
